import { render, staticRenderFns } from "./ReadMoreHover.vue?vue&type=template&id=4f06cf57&"
import script from "./ReadMoreHover.vue?vue&type=script&lang=js&"
export * from "./ReadMoreHover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports